import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable()
export class GeneralService {
  constructor(
    private _datePipe: DatePipe
  ) { }

  /**
   * Converts object to array
   * @param object 
   * @returns object to array 
   */
  convertObjectToArray(object: object): { key: string; value: any; }[] {
    return Object.entries(object).map(([key, value]) => ({ key, value }));
  }

  /**
   * Generates array of years
   * @param [futureYear] 
   * @param [pastYear] 
   * @returns array of years 
   */
  generateArrayOfYears(futureYear: number = 0, pastYear: number = 10): number[] {
    const maximumYear = new Date().getFullYear() + futureYear;
    const minimumYear = new Date().getFullYear() - pastYear;
    let years = [];
    for (let index = maximumYear; index >= minimumYear; index--) {
      years.push(index);
    }
    return years;
  }

  /**
   * Determines whether date is
   * @param value 
   * @returns true if date 
   */
  isDate(value: string): boolean {
    const regex = /(\d{4})-(\d{1,2})-(\d{1,2})/g;
    return regex?.test(value);
  }

  /**
   * Determines whether empty object is
   * @param object 
   * @returns true if empty object 
   */
  isEmptyObject(object: object): boolean {
    return Object.keys(object)?.length ? false : true;
  }

  /**
   * Determines whether object is
   * @param value 
   * @returns  
   */
  isObject(value: any) {
    return value && typeof value === 'object' && value?.constructor === Object;
  }

  /**
   * Compares array
   * @template T 
   * @param a 
   * @param b 
   * @returns true if array 
   */
  compareArray<T>(a: T[], b: T[]): boolean {
    if (a?.length !== b?.length) return false;
    const elements = new Set([...a, ...b]);
    for (const element of elements) {
      const count1 = a?.filter(value => value === element)?.length;
      const count2 = b?.filter(value => value === element)?.length;
      if (count1 !== count2) return false;
    }
    return true;
  }

  /**
   * Gets today date
   * @param [format] 
   * @returns  
   */
  getTodayDate(format = 'yyyy-MM-dd') {
    return this._datePipe.transform(new Date(), format);
  }

  /**
   * Gets previous date by year
   * @param [counter] 
   * @param [format] 
   * @returns  
   */
  getPreviousDateByYear(counter: number = 1, format = 'yyyy-MM-dd') {
    const date = new Date();
    return this._datePipe.transform(date?.setFullYear(date.getFullYear() - counter), format);
  }

  /**
   * Gets timestamp in millisecond
   * @param date 
   * @returns timestamp in millisecond 
   */
  getTimestampInMillisecond(date: Date): number {
    return date ? new Date(date)?.getTime() : 0;
  }

  /**
   * Gets timestamp in second
   * @param date 
   * @returns timestamp in second 
   */
  getTimestampInSecond(date: Date): number {
    return date ? Math.floor(new Date(date)?.getTime() / 1000) : 0;
  }
}
